import { parse as parse_csv } from 'csv-parse/lib/sync'
import Encoding from 'encoding-japanese'

export default {
  methods: {
    // URLパラーメータ文字列の取得
    mixinGetUrlParams(param) {
      const strs = []
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          const element = param[key]
          if (element) strs.push(`${key}=${element}`)
        }
      }
      return strs.join('&')
    },
    // 稼働日をtoStoringへ
    mixinRegularToString(array) {
      return array.toString()
    },
    // 稼働日をsplitへ
    mixinRegularSplit(string) {
      if (!string) return []
      let res = string.split(',')
      return res
    },
    // 配列のある特定のkeyに対して重複しているものを削除するフィルター
    mixinArrayFilter(array, key) {
      if (!this[array]) return
      if (!this[array].length) return
      let duplication = []
      const list = this[array].filter(item => {
        if (duplication.indexOf(item[key]) === -1 && item[key]) {
          duplication.push(item[key])
          return item
        }
      })
      return list
    },
    // 文字からの検索結果を表示させる処理
    mixinListToggle(key, status) {
      let item = document.getElementById(`${key}`)
      setTimeout(() => {
        item.style.display = (status) ? 'block' : 'none'
      }, 200)
    },
    // ディープコピーを関数化
    mixin_deepcopy(value) {
      if (!value) return
      return JSON.parse(JSON.stringify(value))
    },
    // 時間の単位を時間に変更
    mixinHourFix(value, type) {
      if (!value || !type) return 0
      let hourlyPay = 0
      switch (type) {
        case 'sec':
          hourlyPay = (value / 3600)
          break
        case 'min':
          hourlyPay = (value / 60)
          break
        case 'day':
          hourlyPay = (value / 24)
          break
        case 'hour':
        default:
          hourlyPay = value
          break
      }
      return hourlyPay
    },
    // 他のページに遷移する処理
    mixinTransition(path) {
      if (!path) window.location.href = this.$appConfig.ScreenUrl.settingMenu
      window.location.href = process.env.NODE_ENV !== 'development' ? `/base${path}` : `${path}`
    },
    // そのページをリロードする処理
    mixinReload() {
      window.location.reload()
    },
    // 奇数か偶数かを判定する処理
    mixinEvenOrOdd(num) {
      return (num % 2 == 0)
    },
    mixinDownloadCsvBlob(data, fileName) {
      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      const blob = new Blob([bom, data], {type: 'text/csv'})
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(blob)
        const linkEl = document.createElement('a')
        linkEl.href = url
        linkEl.setAttribute('download', fileName)
        document.body.appendChild(linkEl)
        linkEl.click()

        URL.revokeObjectURL(url)
        linkEl.parentNode.removeChild(linkEl)
      }
    },
    mixinReadImportCSV(file, user_parser) {
      // FileReaderオブジェクトを使ってファイル読み込み
      var reader = new FileReader()
      // ファイル読み込みに成功したときの処理
      const loadFunc = () => {
        let result = new Uint8Array(reader.result)
        const detectedEncoding = Encoding.detect(result)

        result = Encoding.convert(result, {
          to: 'unicode',
          from: detectedEncoding,
          type: 'string',
        })
        const data = parse_csv(result)
        user_parser(data)
      }
      reader.onload = loadFunc
      // ファイル読み込みを実行
      reader.readAsArrayBuffer(file)
    },
  },
}
